export { ReactComponent as EyeDropper } from './svgs/eye-dropper.svg';
